/**
 * DossierPage — Hồ sơ dự thi.
 *
 * Phase B (audit 2026-05-22): legacy_single_role flow đã bị xóa. Trang giờ
 * LUÔN render R1SubmissionPage (2 tabs hồng/xanh Hồ sơ 1/Hồ sơ 2). Trước đây
 * có branch fallback sang 2 tab Memorial + Evidence cũ — đã loại bỏ.
 *
 * Nếu cần xem từng phần riêng → vẫn có route trực tiếp `/memorials` và
 * `/evidence` (sidebar admin).
 */
import { lazy, Suspense } from 'react'
import { Box, CircularProgress } from '@mui/material'

const R1SubmissionPage = lazy(() => import('./R1SubmissionPage'))

function PageFallback() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <CircularProgress />
    </Box>
  )
}

export default function DossierPage() {
  return (
    <Suspense fallback={<PageFallback />}>
      <R1SubmissionPage />
    </Suspense>
  )
}
